// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3JPGm","name":"Header_name__3iBZR","birthday":"Header_birthday__6ysbW","skeleton":"Header_skeleton__3fTnn"};